<template>
  <div>
    <el-row
      :gutter="10"
      style="margin-bottom: 10px;"
    >
      <el-col>
        <el-button
          size="mini"
          @click="fetch_contacts(); filter_table('all')"
        >
          {{ contact_label }}
        </el-button>
        <el-button
          type="success"
          size="mini"
          @click="filter_table('customers')"
        >
          {{ customer_label }}
        </el-button>
        <el-button
          type="primary"
          size="mini"
          @click="filter_table('suppliers')"
        >
          {{ supplier_label }}
        </el-button>
        <el-input
          v-model="search_term"
          placeholder="Filter by contact name"
          clearable
          size="small"
          style="width: 250px; margin-left: 10px;"
          @input="debounced_filter"
        />
      </el-col>
    </el-row>

    <el-table
      v-if="paged_contacts.length"
      :data="paged_contacts"
      style="width: 100%"
      border
      row-key="contact_id"
    >
      <el-table-column type="expand">
        <template #default="{ row }">
          <div style="margin-bottom: 10px;">
            <el-button
              size="mini"
              @click="$emit('view-invoices', row)"
            >
              View Invoices
            </el-button>
            <el-button
              size="mini"
              @click="$emit('view-payments', row)"
            >
              View Payments
            </el-button>
            <el-button
              size="mini"
              @click="$emit('view-bills', row)"
            >
              View Bills
            </el-button>
            <el-button
              size="mini"
              @click="$emit('view-credit-notes', row)"
            >
              View Credit Notes
            </el-button>
          </div>
          <recursive-table :data="row" />
        </template>
      </el-table-column>

      <el-table-column
        prop="account_number"
        label="Account Number IQ"
        width="150"
      />
      <el-table-column
        prop="name"
        label="Contact Name"
        width="180"
      />
      <el-table-column
        prop="email_address"
        label="Email"
        width="250"
      />
      <el-table-column
        prop="contact_status"
        label="Status"
        width="120"
      />
    </el-table>

    <div v-else>
      <p>No contacts to display.</p>
    </div>

    <div
      v-if="filtered_contacts.length > page_size"
      style="margin-top: 10px; text-align: left;"
    >
      <el-pagination
        background
        layout="prev, pager, next"
        :total="filtered_contacts.length"
        :page-size="page_size"
        :current-page="current_page"
        @current-change="handle_page_change"
      />
    </div>
  </div>
</template>

<script>
import RecursiveTable from './RecursiveTable.vue';
import { xero_contacts } from '../../api/xero';

export default {
  name: 'XeroContacts',
  components: { RecursiveTable },
  props: { connected: { type: Boolean, required: true } },
  data() {
    return {
      contacts: [],
      filtered_contacts: [],
      totals: { total_contacts: 0, total_customers: 0, total_suppliers: 0 },
      loading: false,
      current_page: 1,
      page_size: 10,
      search_term: '',
      debounce_timer: null
    };
  },
  computed: {
    paged_contacts() {
      const start = (this.current_page - 1) * this.page_size;
      return this.filtered_contacts.slice(start, start + this.page_size);
    },
    customer_label() {
      const count = this.totals.total_customers;
      return `${count} ${count === 1 ? 'Customer' : 'Customers'}`;
    },
    supplier_label() {
      const count = this.totals.total_suppliers;
      return `${count} ${count === 1 ? 'Supplier' : 'Suppliers'}`;
    },
    contact_label() {
      const count = this.totals.total_contacts;
      return `${count} ${count === 1 ? 'Contact' : 'Contacts'}`;
    }
  },
  watch: {
    connected(newVal) {
      if (newVal) this.fetch_contacts();
    }
  },
  methods: {
    async fetch_contacts() {
      if (!this.connected) return;
      this.loading = true;
      try {
        const response = await xero_contacts(this);
        this.contacts = response.data.contacts;
        this.totals = response.data.totals;
        this.filtered_contacts = [...this.contacts];
        this.current_page = 1;
      } catch (err) {
        console.error('Failed to fetch Xero contacts', err);
      } finally {
        this.loading = false;
      }
    },
    filter_table(type) {
      if (type === 'customers') {
        this.filtered_contacts = this.contacts.filter(c => c.is_customer);
      } else if (type === 'suppliers') {
        this.filtered_contacts = this.contacts.filter(c => c.is_supplier);
      } else {
        this.filtered_contacts = [...this.contacts];
      }
      this.current_page = 1;
    },
    debounced_filter() {
      clearTimeout(this.debounce_timer);
      this.debounce_timer = setTimeout(() => {
        this.apply_name_filter();
      }, 300); // 300ms delay
    },
    apply_name_filter() {
      const term = this.search_term.trim().toLowerCase();
      if (!term) {
        this.filtered_contacts = [...this.contacts];
        return;
      }

      this.filtered_contacts = this.contacts.filter(c =>
        (c.name && c.name.toLowerCase().includes(term)) ||
          (c.email_address && c.email_address.toLowerCase().includes(term))
      );
      this.current_page = 1;
    },
    handle_page_change(page) {
      this.current_page = page;
    }
  }
};
</script>
